/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlMatterPermissionFieldsFragment = {
  __typename: "MatterPermission";
  matterId: string;
  canAccess: boolean;
};

export const MatterPermissionFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "matterPermissionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MatterPermission" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "matterId" } },
          { kind: "Field", name: { kind: "Name", value: "canAccess" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlMatterPermissionFieldsFragment, unknown>;
